import CommonStore from './commonStore.js'
import ReservationStore from './reservationStore.js'
import MembershipsStore from './membershipsStore.js'
import EcomStore from './ecomStore.js'
import HandlingSpinner from './HandlingSpinner.vue'

const components = {
    HandlingSpinner,
}

export default {
    install(app, { store }) {
        Object.keys(components).forEach((name) => {
            const component = components[name];

            app.component(name, component);
        })
        
        if (typeof store !== 'undefined') {
            store.registerModule('common', CommonStore)
            store.registerModule('reservations', ReservationStore)
            store.registerModule('memberships', MembershipsStore)
            store.registerModule('ecom', EcomStore)
        }
    }
}